const production = {
  facebook: {
    au: {
      appId: '145621749223301'
    },
    bd: {
      appId: '145621749223301'
    },
    bn: {
      appId: '145621749223301'
    },
    hk: {
      appId: '145621749223301'
    },
    id: {
      appId: '145621749223301'
    },
    jp: {
      appId: '145621749223301'
    },
    kr: {
      appId: '230025685515788'
    },
    la: {
      appId: '145621749223301'
    },
    lk: {
      appId: '145621749223301'
    },
    mm: {
      appId: '145621749223301'
    },
    my: {
      appId: '145621749223301'
    },
    nz: {
      appId: '145621749223301'
    },
    ph: {
      appId: '145621749223301'
    },
    pk: {
      appId: '145621749223301'
    },
    sg: {
      appId: '145621749223301'
    },
    th: {
      appId: '145621749223301'
    },
    tw: {
      appId: '145621749223301'
    },
    vn: {
      appId: '145621749223301'
    }
  }
}
export default production
